export default "__VITE_ASSET__Dd762xeW__"